import "bootstrap/dist/css/bootstrap.min.css";
import "./WhyChooseUs.css";
import "aos/dist/aos.css";

import AOS from "aos";
import { useEffect } from "react";

const WhyChooseUs = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 }); // Animation duration 1s
  }, []);

  return (

    <div className="xx">
    <section className="border-container" data-aos="fade-up">
      <div className="container my-5 text-center">
        {/* Centered Header with Black Background */}
        <div className="our-story-header" data-aos="fade-up">
          <h1 className="fw-bold">Our Story</h1>
        </div>

        <div className="row align-items-center">
          {/* Left Side - Card with Issues */}
          <div className="col-md-6 mb-4">
            <div className="p-4 rounded-4 shadow-lg stat-card" data-aos="zoom-in">
              <div className="text-center mb-3">
                <h2 className="fw-bold stat-number">19+</h2>
                <p className="mb-0 stat-text">Issues</p>
              </div>
            </div>
          </div>

          {/* Right Side - Card with Segments */}
          <div className="col-md-6 mb-4">
            <div className="p-4 rounded-4 shadow-lg stat-card" data-aos="zoom-in">
              <div className="text-center mb-3">
                <h2 className="fw-bold stat-number">5+</h2>
                <p className="mb-0 stat-text">Segments</p>
              </div>
            </div>
          </div>

          {/* Our Story Content */}
          <div className="col-md-12 text-start" data-aos="fade-up">
  <p className="modern-text">
    Encompassing the vision of{" "}
    <span className="highlight">
      "A Thought Leader in Digital Transformation,"
    </span>{" "}
    Exposition strives to bridge the gap between Management and IT through impactful segments such as{" "}
    <span className="highlight">University Business Magazine</span>,{" "}
    <span className="highlight">Edify Inter-University Article Competition</span>,{" "}
    <span className="highlight">Entrepreneurial Community</span>, and{" "}
    <span className="highlight">Industrial Week</span>, and{" "}
    <span className="highlight">Empowering Collaborative Innovation</span>.
  </p>
</div>

        </div>
      </div>
    </section>
    </div>
  );
};

export default WhyChooseUs;
